import { useObjectChainStatus } from '@/hooks/use-object-chain-status';
import clsx from 'clsx';

const statuses = {
  complete: 'text-green-700 bg-green-50 ring-green-600/20',
  created: 'text-gray-600 bg-gray-50 ring-gray-500/10',
  failed: 'text-red-800 bg-red-50 ring-red-600/20',
  running: 'text-orange-800 bg-orange-50 ring-orange-600/20',
  skipped: 'text-purple-800 bg-purple-50 ring-purple-600/20',
};

interface ChainStatusProps {
  uuid: string;
  container: string;
  initialStatus: string;
}

export function ChainStatus({
  initialStatus,
  uuid,
  container,
}: ChainStatusProps) {
  const { data } = useObjectChainStatus(uuid, container);
  const chainStatus = data?.data?.status || initialStatus;

  return (
    <span
      className={clsx(
        statuses[chainStatus as keyof typeof statuses],
        'rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset ml-1'
      )}
    >
      {chainStatus}
    </span>
  );
}
